import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from '@/components/error-boundary'
import { BrandProvider } from '@/providers/brand-provider'
import { useAuthStore } from '@/stores/auth-store'
import { captureTrackingData } from '@/stores/form-store'
import { router } from './router'
import './styles/globals.css'

useAuthStore.getState().initialize()
captureTrackingData()

// In dev mode, bridge browser console + errors to the dev server terminal
if (import.meta.hot) {
  import('virtual:terminal').then(({ terminal }) => {
    // Patch console methods to also forward to dev server
    const origLog = console.log
    const origWarn = console.warn
    const origError = console.error
    console.log = (...args: unknown[]) => { origLog(...args); terminal.log(...args) }
    console.warn = (...args: unknown[]) => { origWarn(...args); terminal.warn(...args) }
    console.error = (...args: unknown[]) => { origError(...args); terminal.error(...args) }

    // Forward uncaught errors
    window.addEventListener('error', e => {
      terminal.error(`[uncaught] ${e.message}`, e.filename ? `\n  at ${e.filename}:${e.lineno}:${e.colno}` : '')
    })
    window.addEventListener('unhandledrejection', e => {
      const reason = e.reason instanceof Error ? `${e.reason.message}\n${e.reason.stack}` : String(e.reason)
      terminal.error(`[unhandled rejection] ${reason}`)
    })
  }).catch(() => { /* terminal not available outside dev */ })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrandProvider>
        <RouterProvider router={router} />
      </BrandProvider>
    </ErrorBoundary>
  </StrictMode>,
)
